import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { cssMainSelector } from "../lib/cssSelectors";
import { withTranslation } from "react-i18next";
import { Label } from "./Label";
import styled, {css} from "styled-components";

const amountPadding = css `padding: ${p => p.theme.spacing.xxs} ${p => p.theme.spacing.xs}`;
const Amount = styled(Label)`
  ${p => cssMainSelector(p.theme.tdsId)} {
    color: ${p => p.theme.color.darkSlateGray};
    border: 1px ${p => p.theme.color.darkSlateGray} solid;
    border-radius: ${p => p.theme.generic.borderRadius};
    background-color: ${p => p.theme.color.white};
    font-size: ${p => p.theme.font.sizeXs};
    font-weight: ${p => p.theme.font.weightNormal};
    line-height: 13px;
    ${amountPadding};
  }
`;

class PhoneMemoryLabel extends PureComponent {
  render() {
    const { amount, t } = this.props;

    return (
      <Amount {...this.props}>
        {amount}
        {t("gb")}
      </Amount>
    );
  }
}

PhoneMemoryLabel.propTypes = {
  amount: PropTypes.number.isRequired
};

export default withTranslation(["phoneMemory"])(PhoneMemoryLabel);
